import React from 'react';
import get from 'lodash/get';
import { useFormContext } from 'react-hook-form';
import { Input } from '../../../../CommonComponents/OPL/Input/Input';
import { Wrapper } from '../../../../CommonComponents/OPL/Wrapper/Wrapper';
import { MarginProps } from '../../../../theme/styledProps';

interface Props extends MarginProps {
  isReview?: boolean;
  fieldName: string;
}

export const BrokerFirmName: React.FC<Props> = ({ isReview, fieldName, ...rest }) => {
  const formBag = useFormContext();
  const {
    formState: { errors },
  } = formBag;

  const isAffiliatedExchangeOrFINRA = formBag.watch('isAffiliatedExchangeOrFINRA');

  if (!isAffiliatedExchangeOrFINRA) {
    return null;
  }

  return (
    <Wrapper {...rest}>
      <Input
        {...formBag.register(fieldName)}
        label={
          isReview
            ? undefined
            : 'Please provide the name of the FINRA member firm or exchange you are affiliated with.'
        }
        type="text"
        placeholder="Name of the firm"
        formVariant={get(errors, fieldName) ? 'error' : undefined}
        helperText={get(errors, fieldName)?.message}
        aria-label="Please provide the name of the FINRA member firm or exchange you are affiliated with."
        maxLength={256}
      />
    </Wrapper>
  );
};
